import { SNACKBAR_VARIANTS } from './constants';

export const ERROR_HANDLER_TYPES = {
  SNACKBAR: 'snakcbar',
  DIALOG: 'dialog',
  TOPBAR: 'topbar',
};

export class SnackbarHandlerSchema {
  type = ERROR_HANDLER_TYPES.SNACKBAR;

  message;

  key;

  status;

  variant;

  constructor(status, message, variant = SNACKBAR_VARIANTS.ERROR) {
    this.key = Date.now();
    this.message = message;
    this.status = status;
    this.variant = variant;
  }

  getMessage = () => `${(this.variant || '').toUpperCase()}: ${this.status} - ${this.message}`;
}
